import React from 'react'
import Card from './Card'
import style from './style.module.scss'
import PropTypes from 'prop-types'
import { getImgURL } from '@shared-submodule/utils'

import CustomLink from '@shared/components/customLink'
import arrow from '@assets/images/ipl/circularArrow.svg'
import MyImage from '@shared/components/myImage'

const DailyNews = ({ data, isMobile = false }) => {
  return (
    <div className='d-flex flex-column mt-2'>
      <div className='d-flex justify-content-between align-items-center'>
        <h4>Daily Articles</h4>
        <CustomLink href='cricket/series/indian-premier-league-2025/news' >
          <a>
            <MyImage src={arrow} alt-='Circular Icon' width={34} height={34} />
          </a>
        </CustomLink>
      </div>
      <div className={`${style.grid} d-none d-md-flex`}>
        <Card news={data?.aResults} />
      </div>
      <div className='d-flex d-md-none flex-column gap-2'>
        {data?.aResults.map((news, i) => {
          if (!isMobile) {
            return (
              <React.Fragment key={i}>
                <CustomLink href={`/${news?.oSeo?.sSlug}`} key={i} >
                  <a>
                    <div key={i} className='d-flex flex-row gap-2 align-items-center'>
                      <MyImage src={getImgURL(news?.oImg?.sUrl)} alt={news?.sTitle} width={84} height={64} className='rounded-3' />
                      <div>
                        <p className='fw-bold fs-sm mb-0'>{news?.sTitle}</p>
                      </div>
                    </div>
                  </a>
                </CustomLink >
                {!(i === data?.aResults.length - 1) && <div className={style.line}></div>}
              </React.Fragment>
            )
          } else {
            return (<>
              <div key={i} className='d-flex flex-row gap-2 align-items-center'>
                <MyImage src={getImgURL(news?.oImg?.sUrl)} alt={news?.sTitle} width={84} height={64} className='rounded-3' />
                <div>
                  <p className='fw-bold fs-sm mb-0'>{news?.sTitle}</p>
                </div>
              </div>
              {!(i === data?.aResults.length - 1) && <div className={style.line}></div>}
            </>
            )
          }
        })}
      </div>
    </div>
  )
}

DailyNews.propTypes = {
  data: PropTypes.object,
  isMobile: PropTypes.bool
}

export default DailyNews
